import React from 'react';
import { arc as d3Arc } from 'd3-shape';
import { Group } from '@vx/group';

export interface Props {
  className?: string;
  fill?: string;
  startAngle?: number;
  endAngle?: number;
  innerRadius?: number;
  outerRadius?: number;
  score: number;
  scaleMin?: number;
  scaleMax?: number;
  cornerRadius?: number;
  stroke?: string;
  strokeWidth?: number | string;
}

export interface PathProps {
  className: string;
  fill: string;
  d: string;
  transform: string;
  stroke: string;
  strokeWidth: number | string;
}

const toRadians = (degrees: number): number => {
  return degrees * (Math.PI / 180);
};

const absMod = (num: number, mod: number): number => {
  return (num + mod) % mod;
};

class ScaledArc extends React.Component<Props, any> {
  static defaultProps = {
    innerRadius: 45,
    outerRadius: 50,
    scaleMin: 0,
    scaleMax: 100,
    cornerRadius: '100%',
    startAngle: 0,
    endAngle: 360,
    stroke: 'transparent',
    strokeWidth: 0,
  };

  public render() {
    const {
      className,
      fill,
      score,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      scaleMin,
      scaleMax,
      stroke,
      strokeWidth,
    } = this.props;

    const realStartAngle: number = 0;
    const absoluteEndAngle: number = absMod(endAngle - startAngle, 360.1);
    const scaledScore: number = (score - scaleMin) / (scaleMax - scaleMin);
    const scoreAngle: number = absoluteEndAngle * scaledScore;

    const path = d3Arc()
      .cornerRadius(outerRadius - innerRadius)
      .outerRadius(outerRadius)
      .innerRadius(innerRadius)
      .startAngle(toRadians(realStartAngle))
      .endAngle(toRadians(scoreAngle));

    const pathProps: PathProps = {
      className,
      fill,
      d: path(null),
      transform: `rotate(${startAngle})`,
      stroke,
      strokeWidth,
    };

    return (
      <Group top={outerRadius} left={outerRadius}>
        <path {...pathProps} />
      </Group>
    );
  }
}

export default ScaledArc;
